import 'swiper/css';

import classnames from 'classnames';
import { FC, useEffect, useState } from 'react';
import { useMedia } from 'react-use';

import { ReactComponent as DollarIcon } from '../../../../../shared/lib/icons/common/dollar.svg';
import { ReactComponent as HandsIcon } from '../../../../../shared/lib/icons/common/hands.svg';
import { ReactComponent as PeopleGroupIcon } from '../../../../../shared/lib/icons/common/people-group.svg';
import { BlockHeader, FadeInContainer } from '../../../../../shared/lib/ui';
import S from './Media.module.scss';
import { useTranslation } from 'react-i18next';

const ITEMS = [
  [
    'kp.svg',
    'sportkp.svg',
    'nvl.svg',
    'arg-and-facts.svg',
    'sport-express.svg',
  ],
  ['ctnews.svg', 'vnimanie.svg', 'curier.svg', '360.svg', 'primpress.svg'],
  ['hi-tech.svg', 'free-press.svg', 'tolk.svg', 'berdsk.svg', 'amc.svg'],
];

export const Media: FC = () => {
  const { t } = useTranslation();

  const isMobile = useMedia('only screen and (max-width: 743px)', false);

  const [sliderPage, setSliderPage] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setSliderPage((prevState) => {
        if (prevState === 3) {
          return 1;
        }

        return prevState + 1;
      });
    }, 3500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <section>
      <BlockHeader
        block={t('webmaster.media_section.title')}
        title={<>{t('webmaster.media_section.subtitle')} </>}
      />
      <div className={S.Advantages}>
        <FadeInContainer>
          <div className={S.Advantage}>
            <span className={S.AdvantageIcon}>
              <HandsIcon />
            </span>

            <p className={S.AdvantageTitle}>100%</p>
            <span className={S.AdvantageDescr}>
              {t('webmaster.media_section.card_1')}
            </span>
          </div>
        </FadeInContainer>
        <FadeInContainer>
          <div className={S.Advantage}>
            <span className={S.AdvantageIcon}>
              <DollarIcon />
            </span>

            <p className={S.AdvantageTitle}>100-250₽</p>
            <span className={S.AdvantageDescr}>
              {t('webmaster.media_section.card_2')}
            </span>
          </div>
        </FadeInContainer>
        <FadeInContainer>
          <div className={S.Advantage}>
            <span className={S.AdvantageIcon}>
              <PeopleGroupIcon />
            </span>

            <p className={S.AdvantageTitle}>2 000+</p>
            <span className={S.AdvantageDescr}>
              {t('webmaster.media_section.card_3')}
            </span>
          </div>
        </FadeInContainer>
      </div>

      {!isMobile && (
        <div>
          <h3 className={S.CompaniesTitle}>
            {' '}
            {t('webmaster.media_section.partners')}
          </h3>

          <div className={S.Slider}>
            {ITEMS.map((item, index) => (
              <div
                key={`${item[0]}-1`}
                className={classnames(S.Row, {
                  [S.IsActive]: index + 1 === sliderPage,
                })}
              >
                {item.map((src) => (
                  <img
                    className={S.Slide}
                    key={src}
                    src={`/assets/icons/logo/${src}`}
                    alt=""
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
